import React, { useState, useEffect } from "react";
import { listProductBy } from "../function/product";
import { useNavigate } from "react-router-dom";
import ProductCard from "../card/ProductCard";
import LoadingCard from "../card/LoadingCard";
import { Carousel } from "react-bootstrap";
import axios from "axios";
import "./HotDeal.css";

const HotDeal = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
    fetchCarouselImages();
  }, []);

  const loadData = () => {
    setLoading(true);
    listProductBy("sold", "desc", 50)
      .then((res) => { setProducts(res.data); setLoading(false); })
      .catch((err) => { console.log(err); setLoading(false); });
  };

  const fetchCarouselImages = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "/admin/getimages-carousel");
      setCarouselImages(response.data.filter((img) => img.isSelected));
    } catch (error) {
      console.error("Error fetching carousel images:", error);
    }
  };

  return (
    <div className="hotdeal-page">
      {/* Carousel */}
      {carouselImages.length > 0 && (
        <div className="hotdeal-carousel">
          <Carousel interval={2000}>
            {carouselImages.map((image) => (
              <Carousel.Item key={image._id}>
                <img className="d-block w-100 hotdeal-carousel-img" src={image.url} alt={image.alt} />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      )}

      {/* Header */}
      <div className="hotdeal-header">
        <span className="hotdeal-icon">🔥</span>
        <h2 className="hotdeal-title">Hot Deal</h2>
        <span className="hotdeal-badge">สินค้าขายดี</span>
      </div>

      {/* Products */}
      <div className="hotdeal-container">
        {loading ? (
          <LoadingCard count={4} />
        ) : (
          <>
            <div className="hotdeal-grid">
              {products.slice(0, 8).map((item, index) => (
                <div key={index} className="hotdeal-item">
                  <ProductCard product={item} />
                </div>
              ))}
            </div>

            {products.length > 8 && (
              <div className="hotdeal-more">
                <button
                  className="btn-hotdeal-more"
                  onClick={() => navigate("/shop")}
                >
                  ดูสินค้าทั้งหมด →
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HotDeal;